export default __webpack_public_path__ + "static/works-845d87f7ab182f594ac64fe10896cea4.png";